import React from 'react';

export default function StatusCsvUploadSection({
  showCsvUpload,
  csvFile,
  csvData,
  csvProcessing,
  csvResults,
  handleCsvFileChange,
  downloadSampleCsv,
  processCsvData,
  resetCsvUpload,
}) {
  return (
    <div className="csv-upload-section">
  {showCsvUpload && (
    <div className="csv-upload-container">
      <div className="csv-upload-header">
        <h3>Bulk Update via CSV</h3>
        <p>Upload CSV with <strong>any number of columns</strong> - I'll automatically find:</p>
        <div className="required-columns">
          <span className="column-tag required">Order ID</span>
          <span className="column-tag required">Status</span>
          <span className="column-tag optional">Tracking Number (optional)</span>
          
        </div>
        <p className="csv-note">✨ All other columns will be ignored!</p>
        
        <div className="sample-download">
          <button onClick={downloadSampleCsv} className="download-sample-btn">
            Download Sample CSV
          </button>
        </div>
      </div>
      
      <div className="csv-upload-content">
        <div className="file-upload-area">
          <input
            type="file"
            accept=".csv"
            onChange={handleCsvFileChange}
            className="csv-file-input"
            id="csvFileInput"
          />
          <label htmlFor="csvFileInput" className="file-upload-label">
            {csvFile ? `${csvFile.name}` : 'Choose CSV File'}
          </label>
        </div>
        
        {csvData.length > 0 && (
          <div className="csv-preview">
            <h4>Preview ({csvData.length} rows)</h4>
            <div className="csv-preview-table">
              <table>
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Status</th>
                    <th>Tracking Number</th>
                    <th>AWB Domestic</th>
                    <th>LM International</th>
                  </tr>
                </thead>
                <tbody>
                  {csvData.slice(0, 5).map((row, index) => (
                    <tr key={index}>
                      <td>{row.orderId}</td>
                      <td>{row.status}</td>
                      <td>{row.trackingNumber || '-'}</td>
                      <td>{row.awbDomestic || '-'}</td>
                      <td>{row.lmInternational || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {csvData.length > 5 && (
                <div className="csv-more-rows">
                  ... and {csvData.length - 5} more rows
                </div>
              )}
            </div>
            
            <div className="csv-actions">
              <button 
                onClick={processCsvData}
                disabled={csvProcessing}
                className="process-csv-btn"
              >
                {csvProcessing ? 'Processing...' : 'Process CSV'}
              </button>
              <button 
                onClick={resetCsvUpload}
                className="reset-csv-btn"
              >
                Reset
              </button>
            </div>
          </div>
        )}
        
        {csvResults && (
          <div className="csv-results">
            <h4>Processing Results</h4>
            <div className="results-summary">
              <span className="result-item success">Success: {csvResults.success}</span>
              <span className="result-item failed">Failed: {csvResults.failed}</span>
              <span className="result-item not-found">Not Found: {csvResults.notFound}</span>
              <span className="result-item total">Total: {csvResults.total}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  )}
</div>
  );
}
